import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:4000/api/v1";

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // Handle specific endpoints that might return 401 legitimately
    const isAuthMeEndpoint = error.config?.url?.includes("/auth/me");

    if (error.response?.status === 401 && !isAuthMeEndpoint) {
      const isAuthPage = ["/login", "/signup"].includes(window.location.pathname);
      if (!isAuthPage) {
        window.location.href = "/login";
      }
    }

    // Suppress console errors for expected 401s on /auth/me
    if (isAuthMeEndpoint && error.response?.status === 401) {
      return Promise.reject({ silent: true });
    }

    // Standardize error format
    const errorMessage = error.response?.data?.error || error.response?.data?.message || error.message || "An unknown error occurred";
    const improvedError = { ...error, message: errorMessage, error: errorMessage };
    return Promise.reject(improvedError);
  }
);
